// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TestConceptGroup
 */
export interface TestConceptGroup {
    /**
     * 
     * @type {Array<string>}
     * @memberof TestConceptGroup
     */
    conditionColumns: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof TestConceptGroup
     */
    enabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TestConceptGroup
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof TestConceptGroup
     */
    instrument?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TestConceptGroup
     */
    instrument_column?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof TestConceptGroup
     */
    name?: string;
    /**
     * 
     * @type {Array<{ [key: string]: string; }>}
     * @memberof TestConceptGroup
     */
    rows: Array<{ [key: string]: string; }>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TestConceptGroup
     */
    valueColumns: Array<string>;
}

/**
 * Check if a given object implements the TestConceptGroup interface.
 */
export function instanceOfTestConceptGroup(value: object): value is TestConceptGroup {
    if (!('conditionColumns' in value) || value['conditionColumns'] === undefined) return false;
    if (!('rows' in value) || value['rows'] === undefined) return false;
    if (!('valueColumns' in value) || value['valueColumns'] === undefined) return false;
    return true;
}

export function TestConceptGroupFromJSON(json: any): TestConceptGroup {
    return TestConceptGroupFromJSONTyped(json, false);
}

export function TestConceptGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): TestConceptGroup {
    if (json == null) {
        return json;
    }
    return {
        
        'conditionColumns': json['conditionColumns'],
        'enabled': json['enabled'] == null ? undefined : json['enabled'],
        'id': json['id'] == null ? undefined : json['id'],
        'instrument': json['instrument'] == null ? undefined : json['instrument'],
        'instrument_column': json['instrument_column'] == null ? undefined : json['instrument_column'],
        'name': json['name'] == null ? undefined : json['name'],
        'rows': json['rows'],
        'valueColumns': json['valueColumns'],
    };
}

export function TestConceptGroupToJSON(json: any): TestConceptGroup {
    return TestConceptGroupToJSONTyped(json, false);
}

export function TestConceptGroupToJSONTyped(value?: TestConceptGroup | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'conditionColumns': value['conditionColumns'],
        'enabled': value['enabled'],
        'id': value['id'],
        'instrument': value['instrument'],
        'instrument_column': value['instrument_column'],
        'name': value['name'],
        'rows': value['rows'],
        'valueColumns': value['valueColumns'],
    };
}
